
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-variant-selector').forEach(function (selector) {
    const productId = selector.dataset.productId;
    const card = selector.closest('.card-wrapper');
    const mediaEl = card.querySelector(`[data-card-image="${productId}"]`);
    const priceEl = card.querySelector(`[data-card-price="${productId}"]`);
    const variantInput = selector.querySelector('.product-variant-id');
    const showStrikeoutEnabled = selector.dataset.showStrikeout === 'true';

    const productJson = document.querySelector(`#ProductJson-${productId}`);
    if (!productJson) return;
    const variants = JSON.parse(productJson.textContent).variants;

    const strikeoutJson = document.querySelector(`#StrikeoutJson-${productId}`);
    const strikeoutMap = strikeoutJson ? JSON.parse(strikeoutJson.textContent) : {};

    function getSelectedOptions() {
      return Array.from(selector.querySelectorAll('.card-option-group')).map(group => {
        return group.querySelector('input[type="radio"]:checked')?.value;
      });
    }

    function findVariant(selectedOptions) {
      return variants.find(v =>
        selectedOptions.every((val, i) => v[`option${i + 1}`] === val)
      );
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updatePrice(variant) {
      if (!priceEl || !variant) return;

      const price = variant.price;
      const compareAt = variant.compare_at_price;
      const strikeoutValue = strikeoutMap[variant.id];

      let wasPrice;
      let nowPrice;

      if (showStrikeoutEnabled) {
        wasPrice = compareAt ? compareAt : price;
        nowPrice = strikeoutValue || price;
      } else {
        wasPrice = compareAt && compareAt > price ? compareAt : null;
        nowPrice = price;
      }

      if (wasPrice) {
        priceEl.innerHTML = `
          <div class="price price--on-sale">
            <div class="price__container">
              <div class="price__sale flex-column justify-right">
                <span class="price-item price-item--regular"><s>${formatMoney(wasPrice)}</s></span>
                <span class="price-item price-item--sale price-item--last">${formatMoney(nowPrice)}</span>
              </div>
            </div>
          </div>`;
      } else {
        priceEl.innerHTML = `
          <div class="price">
            <div class="price__container">
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatMoney(nowPrice)}</span>
              </div>
            </div>
          </div>`;
      }
    }

    function updateImage(variant) {
      if (!mediaEl || !variant.featured_image) return;
      const variantImg = mediaEl.querySelector(`[data-variant-image="${variant.id}"]`);
      if (variantImg) {
        mediaEl.querySelectorAll('img').forEach(img => img.style.display = 'none');
        variantImg.style.display = 'block';
      }
    }

    selector.addEventListener('change', function (e) {
      const input = e.target;
      if (!input.classList.contains('variant-radio')) return;

      const group = input.closest('.card-option-group');
      group.querySelectorAll('.variant-button-label').forEach(l => l.classList.remove('is-selected'));
      input.closest('.variant-button-label').classList.add('is-selected');

      const selected = getSelectedOptions();
      const variant = findVariant(selected);

      if (variant) {
        variantInput.value = variant.id;
        updatePrice(variant);
        updateImage(variant);
      }
    });
  });
});

$(document).ready(function () {
  $(".quantity__button").on("click", function (event) {
    event.preventDefault(); // Prevent default behavior
    
    // Ensure the click is on a valid target within a correct context
    var button = $(event.currentTarget); // Get the clicked button
    var quantityWrapper = button.closest('.quantity-wrapper'); // Find the closest quantity wrapper

    if (!quantityWrapper) {
      return; // If no quantity wrapper is found, return early
    }

    // Get the quantity input within this specific wrapper
    var quantityInput = quantityWrapper.find('.quantity-input');

    if (!quantityInput) {
      return; // If there's no quantity input, exit early
    }

    var currentQty = parseInt(quantityInput.val(), 10); // Get current quantity
    var newQty = currentQty; // Start with the current quantity
    
    // Determine if the clicked button is "plus" or "minus"
    if (button.hasClass('plus')) {
      newQty = currentQty + 1; // Increment by 1
    } else if (button.hasClass('minus') && currentQty > 1) {
      newQty = currentQty - 1; // Decrement by 1, but not below 1
    }

    // Ensure the new quantity doesn't fall below 1
    if (newQty < 1) {
      newQty = 1;
    }

    // Update the quantity input with the new value
    quantityInput.val(newQty.toString());

    // Enable/disable the minus button based on the new quantity
    var minusButton = quantityWrapper.find('.quantity__button.minus');
    if (newQty == 1) {
      minusButton.attr("disabled", "disabled");
    } else {
      minusButton.removeAttr("disabled");
    }
  });
});

function setMainMargin() {
  const nav = document.querySelector('.main-navigation');
  const main = document.querySelector('main');
  if (!nav || !main) return;
  main.style.marginTop = nav.offsetHeight + 'px';
}

setMainMargin();
window.addEventListener('resize', setMainMargin);




(function () {
  function triggerKlaviyoPopup() {
    // Ensure Klaviyo is ready before opening the form
    window._klOnsite = window._klOnsite || [];
    console.log('[Klaviyo Trigger] okendo_quiz_response_id detected — opening form Upszcu');

    setTimeout(() => {
      window._klOnsite.push(['openForm', 'Upszcu']);
    }, 1000);
  }

  function checkForQuizParam() {
    if (window.location.href.includes('okendo_quiz_response_id=')) {
      triggerKlaviyoPopup();
    }
  }

  // Run once on load
  checkForQuizParam();

  // Detect future URL changes (Okendo uses history.pushState)
  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    setTimeout(checkForQuizParam, 500);
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    setTimeout(checkForQuizParam, 500);
  };

  // Also listen for popstate (back/forward navigation)
  window.addEventListener('popstate', checkForQuizParam);
})();
